export default {
  label: {
    exportLabel: 'Download as',
    exportLabelType: 'Download as {type}',
  },
};
